<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :showGoBack="true"
      :title="'IBAN payment'"
    />
    <main
      :class="'scrollable'"
      :style="{paddingTop: '10px', paddingBottom: '20px'}"
    >
      <!-- Beneficiary info -->
      <section
        :style="{marginBottom: '30px'}"
        :class="'container'"
      >
        <span
          :class="'t14'"
          :style="{marginBottom: '10px', display: 'block'}"
          >Beneficiary info</span
        >
        <Input
          :leftIcon="HashSvg"
          :placeholder="'IBAN number'"
          :containerStyle="{marginBottom: '10px'}"
        />
        <Input
          :leftIcon="UserSvg"
          :placeholder="'Beneficiary name'"
          :containerStyle="{marginBottom: '10px'}"
        />
        <Input
          :leftIcon="KeySvg"
          :placeholder="'BIC code'"
          :containerStyle="{marginBottom: '10px'}"
        />
        <Input
          :leftIcon="BriefcaseSvg"
          :placeholder="'Beneficiary bank'"
          :containerStyle="{marginBottom: '10px'}"
        />
        <Input
          :leftIcon="DollarSvg"
          :placeholder="'Amount'"
          :containerStyle="{marginBottom: '10px'}"
        />
        <textarea
          :style="{
            width: '100%',
            height: '120px',
            borderRadius: '10px',
            fontSize: '16px',
            border: '1px solid #FFEFE6',
            paddingLeft: '20px',
            paddingTop: '14px',
            resize: 'none',
          }"
          placeholder="Comment"
        ></textarea>
      </section>

      <!-- Cards -->
      <section :style="{marginBottom: '16px'}">
        <div :class="'container'">
          <span
            :class="'t14'"
            :style="{marginBottom: '10px', display: 'block'}"
            >Use card</span
          >
        </div>
        <swiper-container
          class="swiper"
          space-between="16"
          slides-per-view="auto"
        >
          <swiper-slide
            v-for="(e, index) in cards"
            :key="e.id"
            class="swiper-slide"
            :style="{
              width: 'calc(100% - 40px)',
              padding: '12px',
              backgroundColor: 'var(--white-color)',
              border: '1px solid #FFEFE6',
              borderColor: selectedCard === e.id ? '#6C6D84' : '#FFEFE6',
              borderRadius: '10px',
              gap: '12px',
              marginLeft: index === 0 ? '20px' : '0px',
            }"
            :class="'row-center clickable'"
            @click="setSelectedCard(e.id)"
          >
            <img
              alt="card"
              :src="e.image"
              :class="'clickable'"
              @click="$router.push(e.route)"
              :style="{width: '62px', display: 'block', borderRadius: '6px'}"
            />
            <div
              :style="{
                display: 'flex',
                flexDirection: 'column',
              }"
            >
              <span :class="'t12'"> {{ e.number }} </span>
              <h6>{{ e.balance }} USD</h6>
            </div>
          </swiper-slide>
        </swiper-container>
      </section>

      <!-- Button -->
      <section :style="{padding: '20px'}">
        <Button
          :title="'Send'"
          :onClick="() => $router.push(routes.PAYMENT_SUCCESS)"
        />
      </section>
    </main>
  </div>
</template>

<script setup>
// svg
import {KeySvg} from '@/assets/svg';
import {HashSvg} from '@/assets/svg';
import {UserSvg} from '@/assets/svg';
import {DollarSvg} from '@/assets/svg';
import {BriefcaseSvg} from '@/assets/svg';

// components
import {Input} from '@/components';
import {Button} from '@/components';
import {Header} from '@/components';
import {Background} from '@/components';

// other
import {ref} from 'vue';
import {routes} from '@/routes';
import {useOpacity} from '@/hooks';
const opacity = useOpacity();

const selectedCard = ref(null);
const setSelectedCard = (id) => {
  selectedCard.value = id;
};

// data
const cards = [
  {
    id: 1,
    number: '**** **** **** 1234',
    balance: '4 863.27',
    image: require('@/assets/cards/01.jpg'),
    route: routes.CARD_DETAILS,
  },
  {
    id: 2,
    number: '**** **** **** 1234',
    balance: '4 863.27',
    image: require('@/assets/cards/02.jpg'),
    route: routes.CARD_DETAILS,
  },
];
</script>
